export const validateURL = (rule, value) => {
  if (!value || /^https?:\/\/[^\s$.?#].[^\s]*$/.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject('La URL ingresada no es válida');
};
